import semver from 'semver';

export function supportsHardwareBrightnessContrast(hardwareVersion: string) {
    return semver.satisfies(hardwareVersion, '>=7.4.0');
}
